import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from '@tyro/i18n';
import { OpenBookIcon } from '@tyro/icons';
import {
  useReaderActions,
  useReaderState,
} from '../../store/documentation-reader-provider';

export function DocumentationReaderButton() {
  const { t } = useTranslation(['documentation']);
  const { open } = useReaderActions();
  const { isOpen } = useReaderState();

  return (
    <Tooltip title={t('documentation:reader.title')}>
      <IconButton
        color={isOpen ? 'primary' : 'default'}
        onClick={open}
        sx={{ width: 40, height: 40 }}
        aria-label={t('documentation:reader.title')}
      >
        <OpenBookIcon />
      </IconButton>
    </Tooltip>
  );
}
